import React, {Component} from 'react'
import {Actions} from 'jumpstate'
import {connect} from 'react-redux'
import {Grid, Row, Col} from 'react-bootstrap'
import HorseLoading from '../Common/HorseLoading/HorseLoading'
import './Layout/Store.css'
import HorseshoeBox from './HorseshoeBox'
import {FaMagnet} from '../Common/ReactIcons/icons'

class StoreScreen extends Component {
  constructor (props) {
    super(props)

    this.state = {
      items: [],
      isLoading: false
    }
  }

  componentDidMount () {
    this.setState({isLoading: true})
    if (this.props.store.plans) {
      return this.setState({
        items: this.props.store.plans,
        isLoading: false
      })
    }
    Actions.loadProducts('horseshoe').then((data) => this.setState({isLoading: false, items: data}))
  }

  render () {
    const { auth } = this.props
    const { items, isLoading } = this.state
    return (
      <div id="store-screen">
        <Grid>
          <Row>
            <Col lg={10} lgOffset={1} xs={12} xsOffset={0}>
              <Row className="title">
                <h2>فروشگاه
                </h2>
              </Row>
              {isLoading ? <HorseLoading /> : <Row className="wrapper">
                <div className="store-topic">
                  <FaMagnet /> پلن‌های نعل‌
                </div>
                {items.length > 0 && items.map((item) => (<HorseshoeBox isAuthenticated={auth.isAuthenticated} key={item.id} horseshoe={item} />))}
              </Row>}
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

StoreScreen.fetchData = () => {
  return Actions.loadProducts('horseshoe')
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    store: state.store
  }
}

export default connect(mapStateToProps)(StoreScreen)



// WEBPACK FOOTER //
// ./src/components/Store/StoreScreen.js